import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Path} from '../common/path';
import {RestResult} from '../models/response/rest-result';
import {CommonService} from './common.service';
import {SearchRequest} from '../models/request/search-request';
import {InterestZoneRequest} from '../models/request/buyer/interest-zone-request';
import {InterestZone} from '../models/response/buyer/interest-zone';

@Injectable()
export class InterestZoneService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) {
  }

  getOne(interestZoneId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.INTEREST_ZONE +
      Path.INTEREST_ZONE_ID.replace(':interestZoneId', interestZoneId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.INTEREST_ZONE +
      Path.SEARCH, request,
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  create(request: InterestZoneRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.INTEREST_ZONE, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  remove(interestZoneId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.INTEREST_ZONE +
      Path.INTEREST_ZONE_ID.replace(':interestZoneId', interestZoneId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  update(request: InterestZoneRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.INTEREST_ZONE, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  createOrUpdate(buyerId: number, requests: InterestZone[]): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.INTEREST_ZONE +
      Path.MULTIPLE +
      Path.BUYER_ID.replace(':buyerId', buyerId.toString()), requests).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }
}
